import { Level } from './level';

export class Cube extends Level {
  buildModel() {
  }
}



// WEBPACK FOOTER //
// ./src/common/cube.js